import React, { useState, useEffect } from "react";
import { Button, ButtonProps, Link, styled, Typography } from "@mui/material";
import "../css/login.css";
import login from "../assests/login-logo.png";
import { LoadingButton } from "@mui/lab";
import { useNavigate, useLocation } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import ReactLoading from "react-loading";
import Global from "../utils/global";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const LoadingLoginButton = styled(LoadingButton)<ButtonProps>(() => ({
   color: "var(--buttonText)",
   backgroundColor: "var(--secondary)",
   "&:hover": {
      backgroundColor: "var(--buttonHover)",
   },
}));

const Login = () => {
   const navigate = useNavigate();
   const [userDetails, setUserDetails]:any = useState({});
   const [isLoading, setIsLoading] = useState(false);
   const [type, setType]: any = useState();
   const [open, setOpen] = useState(false);
   const [message, setMessage]: any = useState();

   const { state } = useLocation();

   const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
      props,
      ref
   ) {
      return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
   });

   useEffect(() => {
      if (cookies.get("token")) {
         navigate("/home");
      }
   });

   const loginHandler = async () => {
      if (!userDetails.id || !userDetails.password) {
         setOpen(true);
         setType("warning");
         setMessage("Please provide all information.");
         setIsLoading(false);
         return;
      }
      console.log({ userDetails });
      setIsLoading(true);
      try {
         const response = await fetch(`${Global.API_URL}/auth/login`, {
            method: "post",
            headers: {
               "content-type": "application/json",
            },
            body: JSON.stringify({
               id: userDetails.id,
               password: userDetails.password,
            }),
         });
         const data = await response.json();
         console.log("Login Data : ", data);
         if (data.is_logged_in) {
            console.log("Successful Login");
            // setOpen(true);
            // setType("success");
            // setMessage("This is success message!");
            cookies.set("token", data.token);
            Global.token = data.token;
            Global.isAdmin = data.isAdmin;
            Global.user = data.user;
            // if (state && state.from) {
            //    navigate(state.from);
            // } else {
            //    navigate("/home");
            // }
            navigate("/home");
         } else {
            console.log("Error :", data.message);
            setOpen(true);
            setType("error");
            setMessage(data.message);
            setIsLoading(false);
         }
      } catch (error: any) {
         console.log("Error in catch", error);
         setOpen(true);
         setType("error");
         setMessage("Something went wrong, please try again later!");
         setIsLoading(false);
      }
   };

   return (
      <div className="content">
         <div className="left-content">
            <Typography className="login-text">Login</Typography>
            {/* change- removed extra div and applied style to input class only */}
            <Snackbar
               anchorOrigin={{ vertical: "top", horizontal: "center" }}
               open={open}
               autoHideDuration={6000}
               onClose={() => {
                  setOpen(false);
               }}
               key={"top" + "center"}
            >
               <Alert severity={type}>{message}</Alert>
            </Snackbar>
            <input
               type="text"
               className="username"
               placeholder="Id"
               name="id"
               onChange={(event: any) => {
                  setUserDetails({ ...userDetails, id: event.target.value });
               }}
               onKeyDown={(e)=> {
                  if (e.key === 'Enter') {
                     loginHandler();
                   }
               }}
            />
            <input
               type="password"
               className="password"
               placeholder="Password"
               name="password"
               onChange={(event: any) => {
                  setUserDetails({
                     ...userDetails,
                     password: event.target.value,
                  });
               }}
               onKeyDown={(e)=> {
                  if (e.key === 'Enter') {
                     loginHandler();
                   }
               }}
            />
            {/* <div className="forgot-password">
                <Link href="#">
                  Forgot password?
                </Link>
              </div> */}
            {/* changed - removed extra div and changed the styling */}
            {isLoading ? (
               <ReactLoading
                  type="bubbles"
                  height={"10%"}
                  width={"10%"}
                  className="loading-prop"
               />
            ) : (
               <LoadingLoginButton
                  variant="contained"
                  loading={false}
                  className="login-btn"
                  onClick={() => loginHandler()}
               >
                  <Typography className="login-btn-text">Submit</Typography>
               </LoadingLoginButton>
            )}
         </div>
         <svg
            width="58"
            height="100%"
            // viewBox="0 0 58 720"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ position: "relative", left: "-0.5px" }}
         >
            <path
               d="M0 720V0C13.5 42 58 183.5 58 365C58 541.502 17.3333 672.5 0 720Z"
               fill="#161616"
            />
         </svg>

         <div className="logo">
            <img src={login} className="loginScreen-image" />
         </div>
      </div>
   );
};

export default Login;
